import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EducationalContentPageComponent } from '@com-delta-idp/mnx-skymiles-educational-content-ui';
import { SkeletonLoaderDirective } from '@com-delta-omnichannel/aura';
import { PushModule } from '@ngrx/component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EducationalContentEffects } from './data-access/+state/effects/educational-content.effects';
import * as fromEducationalContentPage from './data-access/+state/reducers/educational-content.reducer';
import { EducationalContentComponent } from './entry-components/educational-content/educational-content.component';

@NgModule({
  imports: [
    CommonModule,
    PushModule,
    EducationalContentPageComponent,
    SkeletonLoaderDirective,
    StoreModule.forFeature(
      fromEducationalContentPage.EDUCATIONAL_PAGE_FEATURE_KEY,
      fromEducationalContentPage.reducer
    ),
    EffectsModule.forFeature([EducationalContentEffects])
  ],
  declarations: [EducationalContentComponent],
  exports: [EducationalContentComponent]
})
export class SmartModule {}
